export interface IClient {
	code: string;
	name: string;
	externalClientId: string;
	carrier: {
		externalIntegrationFlow: TCarrierFlow;
		knownAsName: string;
		code: string;
		name: string;
		customLayout: TCarrierFlow;
	};
}

export interface IState {
	clients: IClient[];
}

export enum ECarriersList {
	CHUBB_CARRIER = 'CHUBB',
	FASCHIM_CARRIER = 'FASCHIM',
	DEFAULT_CARRIER = 'default',
	DECARE = 'DECARE',
}

export type TCarrierFlow = ECarriersList | null;
